const RUBY_PLATE = {
  slug: "ruby-plate",
  name: "Ruby Plate",
  description: "Heavy armor with ruby accents",
  rarity: "uncommon",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 15 },
    { stat: "redColor", value: 8 },
    { stat: "redRes", value: 3 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_red",
    frameIndex: 1
  },
  bodySprite: "characters/body/body_red",
  tags: ["daily-rotation", "metal"]
};
export {
  RUBY_PLATE
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9ydWJ5LXBsYXRlLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJpbXBvcnQgeyBJdGVtRGVmaW5pdGlvbiB9IGZyb20gJy4uLy4uL3R5cGVzJztcblxuZXhwb3J0IGNvbnN0IFJVQllfUExBVEU6IEl0ZW1EZWZpbml0aW9uID0ge1xuICBzbHVnOiAncnVieS1wbGF0ZScsXG4gIG5hbWU6ICdSdWJ5IFBsYXRlJyxcbiAgZGVzY3JpcHRpb246ICdIZWF2eSBhcm1vciB3aXRoIHJ1YnkgYWNjZW50cycsXG4gIHJhcml0eTogJ3VuY29tbW9uJyxcbiAgc2xvdDogJ2FybW9yJyxcbiAgc2hvcENhdGVnb3J5OiAnbWV0YWwtYXJtb3InLFxuICBzdGF0Q2hhbmdlczogW1xuICAgIHsgc3RhdDogJ2FybW9yJywgdmFsdWU6IDE1IH0sXG4gICAgeyBzdGF0OiAncmVkQ29sb3InLCB2YWx1ZTogOCB9LFxuICAgIHsgc3RhdDogJ3JlZFJlcycsIHZhbHVlOiAzIH0sXG4gIF0sXG4gIHNwcml0ZToge1xuICAgIHNoZWV0OiAnd2FyZHJvYmUvbWV0YWwvbWV0YWxfcmVkJyxcbiAgICBmcmFtZUluZGV4OiAxLFxuICB9LFxuICBib2R5U3ByaXRlOiAnY2hhcmFjdGVycy9ib2R5L2JvZHlfcmVkJyxcbiAgdGFnczogWydkYWlseS1yb3RhdGlvbicsICdtZXRhbCddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQUVPLE1BQU0sYUFBNkI7QUFBQSxFQUN4QyxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixRQUFRO0FBQUEsRUFDUixNQUFNO0FBQUEsRUFDTixjQUFjO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWCxFQUFFLE1BQU0sU0FBUyxPQUFPLEdBQUc7QUFBQSxJQUMzQixFQUFFLE1BQU0sWUFBWSxPQUFPLEVBQUU7QUFBQSxJQUM3QixFQUFFLE1BQU0sVUFBVSxPQUFPLEVBQUU7QUFBQSxFQUM3QjtBQUFBLEVBQ0EsUUFBUTtBQUFBLElBQ04sT0FBTztBQUFBLElBQ1AsWUFBWTtBQUFBLEVBQ2Q7QUFBQSxFQUNBLFlBQVk7QUFBQSxFQUNaLE1BQU0sQ0FBQyxrQkFBa0IsT0FBTztBQUNsQzsiLAogICJuYW1lcyI6IFtdCn0K
